export default "__VITE_ASSET__CbNB02F7__"